export class InfoBoxModel {
  public title: string;
  public message: string;
  public show: boolean;

  constructor(init?: Partial<InfoBoxModel>) {
    if (init) {
      this.title = init.title || "Information";
      this.message = init.message || "";
      this.show = init.show;
    }
  }
}
